import React, { Component } from 'react';
import {
  Modal,
  Button,
  Divider,
  Col,
  Row,
  Checkbox,
  Input,
  Select,
  message,
  Form,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';
import { frequentlyUsedCountries, nonFrequentlyUsedCountries } from '../../../constants/constants';

const { Option } = Select;

class GiftReturnsWithoutOrderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: this.props.visible,
      buttonLoading: false,
      orderSearchError: undefined,
    };
  }
  formRef = React.createRef();

  handleCancel = () => {
    this.props.onCancel();
  };

  handleOk = () => {
    this.props.onOk();
  };

  handleSave = async () => {
    try {
      const values = await this.formRef.current.validateFields();
      await this.handleSubmit(values);
    } catch (err) {
      message.error(
        'There is something wrong with the data you entered. Please check again.',
        5
      );
    }
  };

  async handleSubmit(values) {
    try {
      this.setState({
        buttonLoading: true,
        orderSearchError: undefined,
      });
      let {
        buyerName,
        productReturn,
        giftReturnFirstName,
        giftReturnLastName,
        giftReturnCompany,
        giftReturnResolution,
        giftReturnNote,
        giftReturnEmail,
        giftReturnPhone,
        giftReturnAddress,
        giftReturnZipCode,
        giftReturnCity,
        giftReturnState,
        giftReturnStateCode,
        giftReturnCountry,
        giftReturnCountryCode,
      } = values;
      const payload = {
        companyIdentifier: this.props.companyIdentifier,
        typeReturn: 'giftReturn',
        buyerName,
        productReturn,
        giftReturnFirstName,
        giftReturnLastName,
        giftReturnCompany,
        giftReturnResolution,
        giftReturnNote,
        giftReturnEmail,
        giftReturnPhone,
        giftReturnAddress,
        giftReturnZipCode,
        giftReturnCity,
        giftReturnState,
        giftReturnStateCode,
        giftReturnCountry,
        giftReturnCountryCode,
      };
      await axios.post('/api/visitors/return/createGiftReturn', payload);
      this.setState({
        buttonLoading: false,
      });
      message.success('Gift return created successfully', 4);
      this.props.changeTypeReturn('status');
      // this.props.onCancel();
    } catch (err) {
      console.error(err);
      message.error(
        'Unable to search your order at the moment, Please confirm products are available in store.',
        4
      );
      this.setState({
        buttonLoading: false,
      });
    }
  }

  handleCountryChange = (countryCode) => {
    const selectedCountry = [...frequentlyUsedCountries, ...nonFrequentlyUsedCountries].find(
      country => country.code === countryCode
    );
    
    if (selectedCountry) {
      // Set both country name and code in the form
      this.formRef.current.setFieldsValue({
        giftReturnCountry: selectedCountry.name,
        giftReturnCountryCode: selectedCountry.code
      });
    }
  };

  getCountriesList = () => {
    let countriesList = [];
    
    frequentlyUsedCountries.forEach((country) => {
      countriesList.push(
        <Option value={country.code} key={`frequently-${country.code}`}>
          {country.name}
        </Option>
      );
    });

    const disabledOption = (
      <Option value="disabled" key="disabled" disabled={true}>
        ---------
      </Option>
    );
    countriesList.push(disabledOption);

    nonFrequentlyUsedCountries.forEach((country) => {
      countriesList.push(
        <Option value={country.code} key={`non-frequently-${country.code}`}>
          {country.name}
        </Option>
      );
    });

    return countriesList;
  };

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <React.Fragment>
        <Form colon={false} ref={this.formRef}>
          <Form.Item
            label={
              <FormattedMessage
                id="app.visitor.newReturn.buyerName"
                description="Placeholder for order number input"
                defaultMessage="Buyer's name"
              />
            }
            name="buyerName"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.buyerName.warning"
                    description="Warning if user does not enter the buyer's name"
                    defaultMessage="Please enter the buyer's name"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.buyerNamePlaceholder',
                description: 'Placeholder for buyer name input',
                defaultMessage: "Buyer's name",
              })}
            />
          </Form.Item>
          <Form.Item
            label={
              <FormattedMessage
                id="app.visitor.newReturn.productReturn"
                description="Product return"
                defaultMessage="Which product are you returning?"
              />
            }
            name="productReturn"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.productReturn.warning"
                    description="Product return warning"
                    defaultMessage="Please enter your product you would like to return"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.productReturnPlaceholder',
                description: 'Product return',
                defaultMessage: 'Which product are you returning?',
              })}
            />
          </Form.Item>

          <Form.Item
            label={
              <FormattedMessage
                id="app.visitor.newReturn.giftReturnResolution"
                description="Product resolution"
                defaultMessage="Would you like to exchange for something else?"
              />
            }
            name="giftReturnResolution"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.giftReturnResolution.warning"
                    description="Resolution warning"
                    defaultMessage="Please enter your product you would like to return"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.giftReturnResolutionPlaceholder',
                description: 'Product resolution',
                defaultMessage:
                  'Would you like to exchange for something else?',
              })}
            />
          </Form.Item>

          <Form.Item
            name="giftReturnNote"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.giftReturnNote.warning"
                    description="Note for Gift Exchange warning"
                    defaultMessage="Please enter any additional notes"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.giftReturnNote',
                description: 'Note for Gift Exchange"',
                defaultMessage: 'Anything else we should know?',
              })}
            />
          </Form.Item>

          <Form.Item
            name="giftReturnFirstName"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.giftReturnFirstName"
                description="Label for customer name input"
                defaultMessage="Your first name"
              />
            }
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.giftReturnFistName.warning"
                    description="Warning if user does not enter the name"
                    defaultMessage="Please enter your first name"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.giftReturnFirstNamePlaceholder',
                description: 'Placeholder for customer name input',
                defaultMessage: 'Your first name',
              })}
            />
          </Form.Item>
          <Form.Item
            name="giftReturnLastName"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.giftReturnLastName"
                description="Label for customer name input"
                defaultMessage="Your last name"
              />
            }
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.giftReturnLastName.warning"
                    description="Warning if user does not enter the name"
                    defaultMessage="Please enter your last name"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.giftReturnLastNamePlaceholder',
                description: 'Placeholder for customer name input',
                defaultMessage: 'Your last name',
              })}
            />
          </Form.Item>

          <Form.Item
            name="giftReturnCompany"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.giftReturnCompany"
                description="Label for customer's company input"
                defaultMessage="Your company"
              />
            }
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.giftReturnCompany.warning"
                    description="Warning if user does not enter the company"
                    defaultMessage="Please enter your company"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.giftReturnCompanyPlaceholder',
                description: "Placeholder for customer's company input",
                defaultMessage: 'Your company',
              })}
            />
          </Form.Item>

          <Form.Item
            name="giftReturnEmail"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.emailGift"
                description="Placeholder for email input"
                defaultMessage="Email"
              />
            }
            rules={[
              {
                required: true,
                type: 'email',
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.emailGift.warning"
                    description="Warning if user does not enter the email address"
                    defaultMessage="Please enter your email address"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.emailGiftPlaceholder',
                description: 'Placeholder for email input',
                defaultMessage: 'Email',
              })}
            />
          </Form.Item>
          <Form.Item
            name="giftReturnPhone"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.phone"
                description="Placeholder for phone number input"
                defaultMessage="Phone"
              />
            }
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.phone.warning"
                    description="Warning if user does not enter the phone number"
                    defaultMessage="Please enter your phone number"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.phonePlaceholder',
                description: 'Placeholder for phone number input',
                defaultMessage: 'Phone',
              })}
            />
          </Form.Item>
          <Form.Item
            name="giftReturnAddress"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.address"
                description="Placeholder for address input"
                defaultMessage="Address"
              />
            }
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.address.warning"
                    description="Warning if user does not enter the address"
                    defaultMessage="Please enter your address"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.addressPlaceholder',
                description: 'Placeholder for address input',
                defaultMessage: 'Address',
              })}
            />
          </Form.Item>
          <Form.Item
            name="giftReturnZipCode"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.zipCode"
                description="Placeholder for zip code input"
                defaultMessage="Zip Code"
              />
            }
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.zipCode.warning"
                    description="Warning if user does not enter the zip code"
                    defaultMessage="Please enter your zip code"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.zipCodePlaceholder',
                description: 'Placeholder for zip code input',
                defaultMessage: 'Zip Code',
              })}
            />
          </Form.Item>
          <Form.Item
            name="giftReturnCity"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.city"
                description="City for city input"
                defaultMessage="City"
              />
            }
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.city.warning"
                    description="Warning if user does not enter the city"
                    defaultMessage="Please enter your city"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.cityPlaceholder',
                description: 'Placeholder for city input',
                defaultMessage: 'City',
              })}
            />
          </Form.Item>

          <Form.Item
            name="giftReturnState"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.state"
                description="Placeholder for state input"
                defaultMessage="State"
              />
            }
            rules={[
              {
                required: false,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.state.warning"
                    description="Warning if user does not enter the state"
                    defaultMessage="Please enter your state"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.statePlaceholder',
                description: 'Placeholder for state input',
                defaultMessage: 'State',
              })}
            />
          </Form.Item>
          <Form.Item
            name="giftReturnStateCode"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.stateCode"
                description="Placeholder for state code input"
                defaultMessage="State Code"
              />
            }
            rules={[
              {
                required: false,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.stateCode.warning"
                    description="Warning if user does not enter the state code"
                    defaultMessage="Please enter your state code"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.stateCodePlaceholder',
                description: 'Placeholder for state code input',
                defaultMessage: 'State Code',
              })}
            />
          </Form.Item>

          <Form.Item
            name="giftReturnCountrySelect"
            label={
              <FormattedMessage
                id="app.visitor.newReturn.country"
                description="Placeholder for country input"
                defaultMessage="Country"
              />
            }
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="app.visitor.newReturn.country.warning"
                    description="Warning if user does not enter the country"
                    defaultMessage="Please select your country"
                  />
                ),
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select
              placeholder={formatMessage({
                id: 'app.visitor.newReturn.countryPlaceholder',
                description: 'Placeholder for country input',
                defaultMessage: 'Select Country',
              })}
              onChange={this.handleCountryChange}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.getCountriesList()}
            </Select>
          </Form.Item>
          
          {/* Hidden fields to maintain form data structure */}
          <Form.Item name="giftReturnCountry" style={{ display: 'none' }}>
            <Input />
          </Form.Item>
          <Form.Item name="giftReturnCountryCode" style={{ display: 'none' }}>
            <Input />
          </Form.Item>
        </Form>
        <Row
          span={24}
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '20px',
          }}
        >
          {/* <Button type="primary" onClick={this.handleSave}>
              <span style={{ width: 200 }}>Next</span>
            </Button> */}
          <Button
            id="new-gift-return"
            style={{
              width: '100%',
              backgroundColor: this.props.brandColorButton,
              borderColor: this.props.brandColorButton,
            }}
            onClick={this.handleSave}
          >
            <span
              style={{
                color: this.props.brandColorButtonText,
                fontStyle: this.props.brandFontStyle,
              }}
            >
              <FormattedMessage
                id="app.visitor.newReturn.buttonStartGiftReturn"
                description="Button to start a Gift Exchange"
                defaultMessage="Start a Gift Exchange"
                values={{}}
              />
            </span>
          </Button>
        </Row>
      </React.Fragment>
    );
  }
}

export default GiftReturnsWithoutOrderInfo;
